import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import type { AiChatModelOption } from '@/domain/repositories/ai-chat-repository.js';

export type EfModelSelectorProps = {
    value: string;
    models: AiChatModelOption[];
    onChange: (modelId: string) => void;
    label: string;
    disabled?: boolean;
};

export function EfModelSelector({ value, models, onChange, label, disabled = false }: EfModelSelectorProps) {
    return (
        <TextField
            select
            size="small"
            label={label}
            value={value}
            disabled={disabled || models.length === 0}
            onChange={(event) => onChange(event.target.value)}
            data-testid="ef-model-selector"
            sx={{
                minWidth: 180,
                '& .MuiOutlinedInput-root': {
                    bgcolor: 'background.default',
                    borderRadius: 1.5,
                    fontSize: 12
                }
            }}
            slotProps={{
                inputLabel: { sx: { fontSize: 12 } },
                select: { sx: { fontSize: 12 } }
            }}
        >
            {models.map((model) => (
                <MenuItem key={model.id} value={model.id} sx={{ fontSize: 12 }}>
                    {model.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
